export class InsuranceReviewConstants {
  public static columns_options = {
    requested: [
      "lead",
      "client_name",
      "requested_date",
      "quote_date",
      "product",
      "analyst_name",
      "term",
      "brand",
      "model",
      "year",
      "new_car",
      "review_insurance",
    ],
    incident: [
      "lead",
      "client_name",
      "requested_date",
      "quote_date",
      "product",
      "analyst_name",
      "term",
      "brand",
      "model",
      "year",
      "new_car",
      "review_insurance",
    ],
    approved: [
      "lead",
      "client_name",
      "requested_date",
      "product",
      "analyst_name",
      "term",
      "brand",
      "model",
      "year",
      "new_car",
    ],
  };

  public static insurance_process_tabs = [
    { status: "requested", translation: "Solicitados" },
    { status: "incident", translation: "Incidencias" },
    { status: "approved", translation: "Aprobados" },
  ];
}
